import styled from "styled-components";

export const LabelSection = styled.h4`
  margin: 0;
  padding-bottom: 10px;

  & > .component-label > p,
  & > .component-title > p {
    display: inline-block;
    margin: 0;
  }
`;

export const InstructionsBlock = styled.div`
  margin-bottom: 12px;
  font-style: italic;
`;

export const StyledDiv = styled.div``;
